import JotformEmbed from "react-jotform-embed";
import React from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import useEvent from "../../hooks/useEvent";

const EvaluationForm = () => {
  const event = useEvent();
  const currentUser = useCurrentUser();

  if (currentUser && (event === "SEAADE" || event === "IADR")) {
    return (
      <div className="relative">
        {event === "SEAADE" ? (
          <JotformEmbed
            src={`https://form.jotform.com/203368719273462?userId=${currentUser?.ID}&name[first]=${currentUser?.firstname}&name[last]=${currentUser?.lastname}&email=${currentUser?.email}`}
          />
        ) : event === "IADR" ? (
          <JotformEmbed
            src={`https://form.jotform.com/203370437266454?userId=${currentUser?.ID}&name[first]=${currentUser?.firstname}&name[last]=${currentUser?.lastname}&email=${currentUser?.email}`}
          />
        ) : null}
      </div>
    );
  }

  return (
    <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
      No evaluation form.
    </div>
  );
};

export default EvaluationForm;
